import { Box, Modal, Paper, Typography } from "@mui/material";
import { useContext } from "react";
import { OnlineMatchContext } from "../contexts/OnlineMatchContext";
import colors from "../theme/colors";
import fonts from "../theme/fonts";
import { PLAYER } from "../types/players";

// interface OnlineWaitingModalProps {}

const style = {
  position: "absolute" as "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: "80vw",
  maxWidth: 400,
  bgcolor: colors.mediumGreen,
  boxShadow: 24,
  p: 4,
};

export default function OnlineWaitingModal() {
  const {
    online,
    matchPlayers,
    onlinePlayer,
    onlineGameState,
    onlineMatchState,
  } = useContext(OnlineMatchContext);
  const playerWaitingOn =
    !matchPlayers ||
    matchPlayers.includes(PLAYER.FIRST) ||
    matchPlayers.length === 0
      ? PLAYER.SECOND
      : PLAYER.FIRST;
  const someonesThrown: boolean = Boolean(
    onlineGameState &&
      (onlineGameState.team1.players[0].totalThrows > 0 ||
        (onlineGameState.team2.players[0].totalThrows > 0 &&
          onlineMatchState?.completed.legs.length === 0 &&
          onlineMatchState.completed.sets.length === 0))
  );
  return online && playerWaitingOn !== onlinePlayer ? (
    <Modal open={!matchPlayers || matchPlayers.length < 2}>
      <Paper elevation={6}>
        <Box sx={style}>
          <Typography
            color={colors.lightBeige}
            textAlign="center"
            fontSize={fonts.size.large}
            fontFamily={fonts.family.chalk}
          >
            {someonesThrown || playerWaitingOn === PLAYER.FIRST
              ? `${playerWaitingOn} left`
              : `Waiting on ${playerWaitingOn}`}
          </Typography>
        </Box>
      </Paper>
    </Modal>
  ) : null;
}
